<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование объекта в преимуществе" : "Добавление объекта в преимущество"'
    :subtitle='meta.advantage.name ? meta.advantage.name + (meta.advantage.uniqueness_code ? " (уникальность 1C: " + meta.advantage.uniqueness_name + ")" : "") : ""'
  )
  v-card(v-if="meta.advantage && meta.advantage.uniqueness_code")
    v-alert(
      :value="true"
      color="warning"
      icon="warning"
      outline
    ) Данное преимущество является уникальным и назначение объектам ведется в 1С. Все внесенные изменения в данном интерфейсе будут аннулированы после очередной выгрузки из 1С!
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs9)
          v-select(
            v-if='attributes'
            :error='errors.has("complex_id")'
            :error-messages='errors.first("complex_id")'
            :items='attributes'
            item-text='name'
            item-value='id'
            v-model='model.complex_id'
            label='ЖК'
            @change="onChangeComplex"
          )
        v-flex(xs3)
          v-checkbox(
            v-model='model.published'
            label='Публиковать на сайте'
            color='primary'
          )
        v-flex(xs12)
          v-select(
            :disabled='disabledField'
            :items='current_complex ? current_complex.objects : []'
            item-value='id'
            item-text='name'
            v-model='model.object_ids'
            label="Объекты"
            multiple
            chips
            @change="onChangeObjects"
          )
        v-flex(xs12)
          div(:class='["subheading font-weight-medium", { disabledField }]') Выберите подъезды
          div(class='mt-3 pt-3 pl-3 pr-3 floors-picker')
            v-checkbox(
              :disabled='disabledField'
              v-for='section in sections'
              :key='section'
              :value='section'
              :label='section.toString()'
              :error='errors.has("sections")'
              :error-messages='errors.first("sections")'
              v-model='model.sections'
              color='success'
              class='floor-checker-btn mb-0 mt-1 mr-4'
            )
        v-flex(xs12)
          div(:class='["subheading font-weight-medium", { disabledField }]') Выберите этажи
          div(class='mt-3 pt-3 pl-3 pr-3 floors-picker')
            v-checkbox(
              :disabled='disabledField'
              v-for='floor in floors'
              :key='floor'
              :value='floor'
              :label='floor.toString()'
              :error='errors.has("floors")'
              :error-messages='errors.first("floors")'
              v-model='model.floors'
              color='success'
              class='floor-checker-btn mb-0 mt-1 mr-4'
            )
        v-flex(xs12)
          div(:class='["subheading font-weight-medium", { disabledField }]') Выберите номера стояков
          div(class='mt-3 pt-3 pl-3 pr-3 floors-picker')
            v-checkbox(
              :disabled='disabledField'
              v-for='num in apartment_numbers_on_floor'
              :key='num'
              :value='num'
              :label='num.toString()'
              :error='errors.has("apartment_numbers_on_floor")'
              :error-messages='errors.first("apartment_numbers_on_floor")'
              v-model='model.apartment_numbers_on_floor'
              color='success'
              class='floor-checker-btn mb-0 mt-1 mr-4'
            )
        v-flex(xs6)
          v-text-field(
            :disabled='disabledNumField'
            :error='errors.has("apartment_number")'
            :error-messages='errors.first("apartment_number")'
            v-model='model.apartment_number'
            label='Номер квартиры'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import http from '@/http'
import {mapActions, mapGetters} from 'vuex'
import { sortBy } from 'lodash'

export default {
  props: ['id', 'advantageId'],

  data: () => ({
    model: {
      published: false,
      sections: [],
      floors: [],
      apartment_numbers_on_floor: [],
      object_ids: [],
      apartment_number: ''
    },
    attributes: [],
    meta: {},
    current_complex: {},
    sections: [],
    floors: [],
    apartment_numbers_on_floor: []
  }),

  async created() {
    this.fetchAttributes()
    if (this.id===undefined) return
    this.updateItem()
  },

  methods: {
    async updateItem() {
      const response = await this.fetchSingle({customUrl: `advantages/${this.advantageId}/assignments/${this.id}`, id: this.id })
      this.model = response.data
    },

    async fetchAttributes() {
      try {
        const res = await http.get(`/advantages/${this.advantageId}/assignments/attributes`)
        this.attributes = res.data
        this.meta = res.meta
        this.setCurrentData()
      } catch(error) {
        this.$root.showSnack('Ошибка загрузки атрибутов')
      }
    },

    async onSave() {
      try {
        if (this.id) {
          await this.update({
            customUrl: `advantages/${this.advantageId}/assignments/${this.id}`,
            id: this.id,
            data: this.model
          })
        } else {
          await this.create({
            customUrl: `advantages/${this.advantageId}/assignments/`,
            data: this.model
          })
        }

        this.$root.showSnack('Сохранено')
        this.$router.push({ name: 'Complexes.Advantages.ObjectsList', params: { advantageId: this.advantageId } })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    vError(index, key) {
      if (this.bErrors[index] && this.bErrors[index][key]) {
        return this.bErrors[index][key]
      }
    },

    onChangeObjects(objects) {
      this.setCurrentData()
      if (objects.length !== 1) {
        this.model.apartment_number = ''
      }
    },

    onChangeComplex() {
      this.clearData()
      this.setCurrentData()
    },

    setCurrentData() {
      this.current_complex = this.attributes.find((item)=> item.id === this.model.complex_id)
      let sections = []
      let floors = []
      let apartment_numbers_on_floor = []

      if (!this.current_complex) return

      if (this.model.object_ids && this.model.object_ids.length > 0) {
        this.model.object_ids.map((objectId)=> {
          let object = this.current_complex.objects.find((item)=> item.id === objectId)
          if (object) {
            // если выбран объект(ы), то объединяем sections, floors и apartment_numbers_on_floor
            // для всех выбранных объектов(уникальные по всем объектам)
            sections = [...new Set([...sections,...object.sections])]
            floors = [...new Set([...floors,...object.floors])]
            apartment_numbers_on_floor = [...new Set([...apartment_numbers_on_floor,...object.apartment_numbers_on_floor])]
          }
        })
      }

      this.sections = sections.length ? sortBy(sections) : this.current_complex.sections
      this.floors = floors.length ? sortBy(floors) : this.current_complex.floors
      this.apartment_numbers_on_floor = apartment_numbers_on_floor.length ? sortBy(apartment_numbers_on_floor) : this.current_complex.apartment_numbers_on_floor
    },

    clearData() {
      this.current_complex = {}
      this.sections = []
      this.floors = []
      this.apartment_numbers_on_floor=[]
      this.model.sections = []
      this.model.floors = []
      this.model.apartment_numbers_on_floor = []
      this.model.apartment_number = ''
      this.model.object_ids = []
    },

    ...mapActions('objects/advantages', [
      'fetchSingle',
      'update',
      'create'
    ])
  },

  computed: {
    disabledNumField: function () {
      return !this.model || (this.model && this.model.object_ids.length !==1)
    },
    disabledField: function () {
      return !this.model || !this.model.complex_id
    },
    ...mapGetters('objects/advantages', ['isLoading'])
  }
}
</script>

<style scoped>
.small textarea {
  font-size: 12px;
}
.floor-checker-btn {
  margin-right: 16px;
  display: inline-block;
}
.floors-picker {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.02);
}
.placements-list >>> tbody tr {
  border: 0 !important;
}
.disabledField {
  color: rgba(0,0,0,.54);
}
</style>
